import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Separator } from "react-aria-components";
import { divider } from "./Divider.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseDivider = (t0, ref) => {
  const $ = _c(7);
  const {
    variant: t1,
    orientation: t2
  } = t0;
  const variant = t1 === undefined ? "normal" : t1;
  const orientation = t2 === undefined ? "horizontal" : t2;
  let t3;
  if ($[0] !== orientation || $[1] !== variant) {
    t3 = divider({
      variant,
      orientation
    });
    $[0] = orientation;
    $[1] = variant;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== orientation || $[4] !== ref || $[5] !== t3) {
    t4 = /*#__PURE__*/_jsx(Separator, {
      className: t3,
      orientation: orientation,
      ref: ref
    });
    $[3] = orientation;
    $[4] = ref;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const Divider = /*#__PURE__*/React.forwardRef(BaseDivider);
//# sourceMappingURL=Divider.js.map